import './gt-4';
// analytics网站语言对应的geetest的语言
// https://docs.geetest.com/gt4/apirefer/api/web#product
const langMap = {
    cn: 'zho',
    en: 'eng',
    tw: 'zho-tw',
    jp: 'eng',
    de: 'eng',
};

export const geetestEnabledErrorCode = [
    '60100',
    '60101',
    '60200',
    '60201',
    '60202',
    '60204',
    '60205',
    '60500'
];

export function geetestValidate({
    captchaId,
    outside,
    hideClose,
    lang = 'en',
    appendDom,
}) {
    return new Promise((resolve, reject) => {
        window.initGeetest4({
            captchaId,
            product: 'bind',
            outside,
            hideClose,
            language: langMap[lang],
        }, function(captchaObj) {
            if (appendDom) captchaObj.appendTo(appendDom);
            // 加载完毕
            captchaObj.onReady(function() {
                captchaObj.showBox();
            });
            // 验证成功执行
            captchaObj.onSuccess(function() {
                const validRes = captchaObj.getValidate();
                captchaObj.destroy();
                resolve(validRes);
            });
            // 验证失败执行
            captchaObj.onFail(function() {
            });
            // 验证错误
            captchaObj.onError(function(error) {
                reject(error);
            });
        });
    });
}
